import { Trans } from "react-i18next";

import { colors } from "@dotnet/telematics-design-system";

import { body2SemiBold } from "shared/styles/typography";

import { CountTextProps } from "./types";

const CountText = ({
    compatibleCount,
    totalCount,
    hasCreateForIncompatible
}: CountTextProps) => {
    const { gray700, gray900 } = colors;

    return (
        <p
            css={[
                body2SemiBold,
                {
                    color: gray700,
                    margin: "12px 0 0 0",

                    "& > span": {
                        color: gray900,
                        fontWeight: 600
                    }
                }
            ]}
        >
            <Trans
                i18nKey="Dialog##platform compatibility##count text"
                values={{
                    compatibleCount: hasCreateForIncompatible
                        ? totalCount
                        : compatibleCount,
                    totalCount
                }}
                components={{
                    1: <span />
                }}
            />
        </p>
    );
};

export default CountText;
